import { FieldNames } from 'Constants/FieldNames'

export const FIELDS_ARRAY = [
	FieldNames.INTEGRATION_CHANNEL_IDS,
	FieldNames.REQUIRED_PRODUCT_IDS,
	FieldNames.FIELDS,
	FieldNames.REQUIRED_FIELDS,
	FieldNames.HIDDEN_FIELDS,
	FieldNames.SPECIAL_OFFER_IDS,
]
